import type { ImageContentFit } from "expo-image";
/* ----------------- UI Components --------------- */
import { useMemo } from "react";
import { type ViewStyle, useWindowDimensions } from "react-native";
import { useDevice } from "../../useDevice";
import { ScrollButtonFlatlist } from "../ChatUI/ScrollButtonFlatlist";
import { ZoomImage } from "../MarkdownRenderer/ZoomImage";
import { calculateCardsToShow } from "./helpers";

export type ImageType = {
	id: string;
	url: string;
	name?: string;
	caption?: string;
};
interface Props {
	images: ImageType[];
	containerStyle?: ViewStyle;
	useResponsiveImageWidthWeb?: boolean;
	contentFit?: ImageContentFit;
	customImageHeight?: number;
	customImageWidth?: number;
}
const ImagesCarousel = ({
	images,
	containerStyle,
	useResponsiveImageWidthWeb,
	contentFit,
	customImageHeight,
	customImageWidth,
}: Props) => {
	const { width } = useWindowDimensions();
	const imageWidth = useMemo(() => {
		const cardsToShow = calculateCardsToShow(width);
		return (width - 16 * (cardsToShow + 1)) / cardsToShow;
	}, [width]);

	const { isMobile } = useDevice();

	const imageHeight = isMobile ? 200 : customImageHeight || 300;

	return (
		<ScrollButtonFlatlist
			data={images}
			keyExtractor={(item) => item.id}
			renderItem={({ item, index }) => {
				return (
					<ZoomImage
						width={
							isMobile || useResponsiveImageWidthWeb
								? imageWidth
								: customImageWidth || 300
						}
						height={imageHeight}
						url={item.url}
						allImages={images}
						name={item.name}
						borderRadius={12}
						contentFit={contentFit}
						initialIndex={index}
					/>
				);
			}}
			horizontal
			showsHorizontalScrollIndicator={true}
			contentContainerStyle={{
				paddingBottom: 8,
				gap: 16,
				justifyContent: "center",
				alignItems: "center",
				width: images.length <= 2 ? "100%" : "auto",
				...(containerStyle || {}),
			}}
		/>
	);
};

export default ImagesCarousel;
